'use strict';
import MxEnum from './MxEnum';
import './mx-lodash.js';

import { utils } from './mx-utils.js';

const utilsModule = angular
	.module('mx.utils', [])
	.factory('mx.utils.MxEnum', function utilsMEnum() {
		return MxEnum;
	})
	.value('mx.utils', utils).name;

export { utils, utilsModule };
